<template>
  <div class="observa4-results-table">
    <table class="table table-responsive">
      <thead>
      <tr>
        <td></td>
        <td v-for="(c, k) in sheetFilter" :key="`column-${k}`" v-if="c"
            :class="`bg-${k} text-center summary-column`">
          {{ sc.cat.bySheet[k] }}
        </td>
      </tr>
      </thead>
      <tbody>
      <template v-for="s in summary">
        <tr v-for="(l, k) in s.lines"
            :key="`${s.key}-${k}`"
            :class="`${l.main ? `line-${s.key}` : ''}`">
          <td v-html="l.label"></td>
          <td v-for="(c, t) in sheetFilter" v-if="c"
              :key="`${s.key}-${k}-${t}`"
              class="line-value">
            <div v-if="l[t]">
              <tooltip :text="l[t].tt">
                <div>
                  <span :class="`label label-${l[t].c}`">{{l[t].v}}%</span>
                  <span v-if="l[t].w && !showRatio"
                        class="glyphicon glyphicon-exclamation-sign summary-warning text-warning">
                  </span>
                </div>
              </tooltip>
              <div v-if="showRatio">
                <span class="ratio-text"
                      v-html="l[t].splittedText.sampleRatio">
                </span>
                <span v-if="l[t].w"
                      class="glyphicon glyphicon-exclamation-sign summary-warning text-warning">
                </span>
              </div>
            </div>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import sc from '@/sui/components/results/sc/observa4'

export default {
  name: 'establishment-o4-table-results',

  props: {
    sheetFilter: {
      type: Object,
      required: true
    },

    summary: {
      type: Array,
      required: true
    },

    showRatio: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      sc: sc
    }
  }
}

</script>
<style scoped>
.observa4-results-table {
  .summary-column {
    max-width: 10rem;
  }

  .line-value {
    text-align: center;
    font-size: 110%;
  }

  .ratio-text {
    font-size: 70%;
  }

  .summary-warning {
    font-size: 70%;
    margin-left: 0.2rem;
  }

}

</style>
